function _s(o, i, p, l) { void 0 === i && (i = 400), void 0 === l && (l = !1), o.style.overflow = "hidden", l && (o.style.display = "block"); var n, t = window.getComputedStyle(o), s = parseFloat(t.getPropertyValue("height")), a = parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("padding-bottom")), y = parseFloat(t.getPropertyValue("margin-top")), d = parseFloat(t.getPropertyValue("margin-bottom")), g = s / i, m = a / i, h = r / i, u = y / i, x = d / i; window.requestAnimationFrame(function t(e) { void 0 === n && (n = e); e -= n; l ? (o.style.height = g * e + "px", o.style.paddingTop = m * e + "px", o.style.paddingBottom = h * e + "px", o.style.marginTop = u * e + "px", o.style.marginBottom = x * e + "px") : (o.style.height = s - g * e + "px", o.style.paddingTop = a - m * e + "px", o.style.paddingBottom = r - h * e + "px", o.style.marginTop = y - u * e + "px", o.style.marginBottom = d - x * e + "px"), i <= e ? (o.style.height = "", o.style.paddingTop = "", o.style.paddingBottom = "", o.style.marginTop = "", o.style.marginBottom = "", o.style.overflow = "", l || (o.style.display = "none"), "function" == typeof p && p()) : window.requestAnimationFrame(t) }) } HTMLElement.prototype.slideToggle = function (t, e) { 0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e) }, HTMLElement.prototype.slideUp = function (t, e) { _s(this, t, e) }, HTMLElement.prototype.slideDown = function (t, e) { _s(this, t, e, !0) };

let packItems = []

let PACK_SELECTION = {
    pack_items: packItems
};

let total_quantity_global = false;

const passedIds = new Set();
for (let item of bundleData.bundle_products) {
    const variantId = item.variants[0].id;

    if (!passedIds.has(variantId)) {
        const newItem = {
            id: variantId,
            productId: item.id,
            handle: item.handle,
             weight:  item.variants[0].title.split('g')[0] == "Default Title" ? 200 : item.variants[0].title.split('g')[0],
            title: item.title,
            quantity: 0,
            price: item.price
        };
        packItems.push(newItem);
        passedIds.add(variantId);
    }
}

// Subscription helpers — child products in the bundle each have their OWN
// selling-plan IDs, even when the frequency name (e.g. "Tous les mois") matches.
// We resolve plan IDs and prices per-handle from bundleData at submit / display time.
function getBundleProductByHandle(handle) {
    if (typeof bundleData === 'undefined' || !bundleData.bundle_products) return null;
    return bundleData.bundle_products.find((p) => p.handle === handle) || null;
}

function getActiveFrequencyName() {
    const tab = document.querySelector('.abos__frequency-tab.actif[data-selling-plan-id]');
    return tab ? tab.dataset.sellingPlanValue : null;
}

function getSellingPlanIdForHandle(handle) {
    const planName = getActiveFrequencyName();
    if (!planName) return null;
    const product = getBundleProductByHandle(handle);
    if (!product || !product.selling_plan_groups) return null;
    for (const group of product.selling_plan_groups) {
        for (const plan of group.selling_plans) {
            if (plan.name === planName) return plan.id;
        }
    }
    return null;
}

function getVariantSubscriptionPrice(handle, variantId, planName) {
    const product = getBundleProductByHandle(handle);
    if (!product) return null;
    const variant = product.variants.find((v) => v.id === variantId) || product.variants[0];
    if (!variant) return null;
    if (!planName || !variant.selling_plan_allocations) return variant.price;
    let planId = null;
    for (const group of product.selling_plan_groups || []) {
        for (const plan of group.selling_plans) {
            if (plan.name === planName) { planId = plan.id; break; }
        }
        if (planId) break;
    }
    if (!planId) return variant.price;
    const alloc = variant.selling_plan_allocations.find((a) => a.selling_plan_id === planId);
    return alloc ? alloc.price : variant.price;
}

function isAboActive() {
    return !!document.querySelector('.abos__abo.active');
}

function getCurrentTotalCoffees() {
    if (typeof PACK_SELECTION === 'undefined' || !PACK_SELECTION.pack_items) return 0;
    return PACK_SELECTION.pack_items.reduce((sum, item) => sum + (item.quantity || 0), 0);
}

// Gift selector — only shown with subscription orders. Tier mode (used on
// the personalise template) reveals each tier individually as the matching
// progress threshold is reached, and hides the whole block when no tier
// is reached. Legacy mode is a single group and is shown whenever
// subscription is active.
function updateGiftSelectorVisibility(totalCoffees) {
    const selector = document.querySelector('.product-form__gift-selector');
    if (!selector) return;

    const requireAbo = selector.dataset.giftNoAbo !== 'true';
    const isAbo = !requireAbo || isAboActive();
    const isTierMode = selector.dataset.giftSelectorMode === 'tier';
    if (totalCoffees == null) totalCoffees = getCurrentTotalCoffees();

    if (!isAbo) {
        selector.classList.add('hidden');
        selector.querySelectorAll('.product-form__gift-card.active').forEach((c) => c.classList.remove('active'));
        if (!isTierMode) {
            window.SELECTED_GIFT_VARIANT_ID = null;
            const wrap = document.querySelector('[data-gift-banner-price-wrapper]');
            if (wrap) wrap.style.display = 'none';
        }
        return;
    }

    if (!isTierMode) {
        selector.classList.remove('hidden');
        return;
    }

    let anyVisible = false;
    let firstVisibleCard = null;
    selector.querySelectorAll('.product-form__gift-tier').forEach((tier) => {
        const threshold = Number(tier.dataset.giftTierThreshold);
        const reached = !Number.isNaN(threshold) && totalCoffees >= threshold;
        if (reached) {
            tier.classList.remove('hidden');
            anyVisible = true;
            if (!firstVisibleCard) {
                firstVisibleCard = tier.querySelector('.product-form__gift-card');
            }
        } else {
            tier.classList.add('hidden');
            tier.querySelectorAll('.product-form__gift-card.active').forEach((c) => c.classList.remove('active'));
        }
    });

    if (anyVisible) {
        const visibleActive = selector.querySelector('.product-form__gift-tier:not(.hidden) .product-form__gift-card.active');
        if (!visibleActive && firstVisibleCard) firstVisibleCard.classList.add('active');
    }
    selector.classList.toggle('hidden', !anyVisible);
}

// Legacy progress-gifts block (compact thumbnails) — used by boîte mode.
// Each .product-form__progress-gift carries data-progress-gift-step; the
// matching threshold lives on .product-form__progress--bar-item-{step}
// [data-reduction-step]. Block visibility is purely quantity-driven; no
// subscription gating.
function updateProgressGiftsDOM(total_coffees = 0) {
    const wrapper = document.querySelector('.product-form__progress-gifts');
    if (!wrapper) return;
    const blocks = wrapper.querySelectorAll('.product-form__progress-gift');
    let firstVisibleSeen = false;
    let anyVisible = false;

    blocks.forEach((block) => {
        const step = Number(block.dataset.progressGiftStep);
        const progressBarItem = document.querySelector(
            `.product-form__progress--bar-item-${step}[data-reduction-step]`
        );
        const threshold = progressBarItem
            ? Number(progressBarItem.dataset.reductionStep)
            : Infinity;
        const reached = total_coffees >= threshold;

        const prev = block.previousElementSibling;
        const separator = prev && prev.classList.contains('product-form__progress-gifts-separator')
            ? prev
            : null;

        if (reached) {
            block.classList.remove('hidden');
            anyVisible = true;
            if (separator) separator.classList.toggle('hidden', !firstVisibleSeen);
            firstVisibleSeen = true;
            if (!block.querySelector('.product-form__progress-gift-item.active')) {
                const firstItem = block.querySelector('.product-form__progress-gift-item');
                if (firstItem) firstItem.classList.add('active');
            }
            const activeItem = block.querySelector('.product-form__progress-gift-item.active');
            const priceEl = block.querySelector('[data-progress-gift-price]');
            if (activeItem && priceEl) {
                priceEl.textContent = activeItem.dataset.giftPrice || '';
            }
        } else {
            block.classList.add('hidden');
            if (separator) separator.classList.add('hidden');
        }
    });

    wrapper.classList.toggle('hidden', !anyVisible);
    if (!anyVisible) {
        wrapper.querySelectorAll('.product-form__progress-gift-item.active')
            .forEach((el) => el.classList.remove('active'));
    }
}

// Click handler for progress-gift thumbnails (boîte mode).
document.addEventListener('click', (event) => {
    const item = event.target.closest('.product-form__progress-gift-item[data-gift-variant-id]');
    if (!item) return;
    const block = item.closest('.product-form__progress-gift');
    if (!block) return;
    block.querySelectorAll('.product-form__progress-gift-item').forEach((i) => i.classList.remove('active'));
    item.classList.add('active');
    const priceEl = block.querySelector('[data-progress-gift-price]');
    if (priceEl) priceEl.textContent = item.dataset.giftPrice || '';
    const nameEl = block.querySelector('[data-progress-gift-selected-name]');
    if (nameEl) nameEl.textContent = item.getAttribute('title') || '';
});

// Sum of the active gifts' market prices across visible progress-gift
// blocks (boîte-mode legacy block). Returns cents. Returns 0 when no
// progress-gift block is visible / no active item — safe on templates
// that use the new gift-selector instead.
function getActiveGiftBonusCents() {
    let bonus = 0;
    document.querySelectorAll('.product-form__progress-gift:not(.hidden)').forEach((block) => {
        const activeItem = block.querySelector('.product-form__progress-gift-item.active');
        if (!activeItem) return;
        const raw = activeItem.dataset.giftPrice || '';
        const match = raw.replace(/\s|€| /g, '').replace(',', '.').match(/-?\d+(\.\d+)?/);
        if (!match) return;
        const cents = Math.round(parseFloat(match[0]) * 100);
        if (!Number.isNaN(cents)) bonus += cents;
    });
    return bonus;
}

// Read the current quantity-tier reduction from the DOM. Highest reached
// non-gift step wins. Returns a percentage (0..100).
function getCurrentTierReduction() {
    const total = getCurrentTotalCoffees();
    let reduction = 0;
    [1, 2, 3].forEach((i) => {
        const el = document.querySelector(`.product-form__progress--bar-item-${i}[data-reduction-step]`);
        if (!el) return;
        const threshold = Number(el.dataset.reductionStep);
        const r = Number(el.dataset.reduction);
        const isGift = el.dataset.rewardType === 'gift';
        if (!isGift && !Number.isNaN(threshold) && !Number.isNaN(r) && total >= threshold) {
            reduction = r;
        }
    });
    return reduction;
}

function updateAboPriceLabels() {
    if (typeof PACK_SELECTION === 'undefined' || !PACK_SELECTION.pack_items) return;
    const planName = getActiveFrequencyName();
    const tierReduction = getCurrentTierReduction();
    // Base totals are the un-discounted subtotals (no tier, no subscription).
    // We apply the tier reduction afterwards, line-by-line (rounded per line)
    // so the final amount matches Shopify's cart-side line-discount math.
    let baseTotal = 0;
    let oneShootTotal = 0;
    let aboTotal = 0;
    for (const item of PACK_SELECTION.pack_items) {
        if (!item.quantity) continue;
        const oneShootLine = item.price * item.quantity;
        baseTotal += oneShootLine;
        oneShootTotal += oneShootLine - Math.round(oneShootLine * tierReduction / 100);
        const subUnit = getVariantSubscriptionPrice(item.handle, item.id, planName);
        const aboLine = (subUnit != null ? subUnit : item.price) * item.quantity;
        aboTotal += aboLine - Math.round(aboLine * tierReduction / 100);
    }
    const fmt = (cents) => (cents / 100).toFixed(2) + '€';
    const oneShootEl = document.querySelector('[data-one-shoot-price]');
    const oneShootCompareEl = document.querySelector('[data-one-shoot-compare]');
    const aboEl = document.querySelector('[data-abo-price]');
    const aboCompareEl = document.querySelector('[data-abo-compare]');
    if (oneShootEl) oneShootEl.textContent = fmt(oneShootTotal);
    if (oneShootCompareEl) {
        if (oneShootTotal < baseTotal) {
            oneShootCompareEl.textContent = fmt(baseTotal);
            oneShootCompareEl.classList.remove('hidden');
        } else {
            oneShootCompareEl.textContent = '';
            oneShootCompareEl.classList.add('hidden');
        }
    }
    if (aboEl) aboEl.textContent = fmt(aboTotal);
    // Abo compare is the original (un-discounted) price, not the one-shoot price
    // after tier reduction. Falls back to one-shoot when no abo discount applies.
    if (aboCompareEl) {
        const aboCompareTarget = aboTotal < baseTotal ? baseTotal : 0;
        aboCompareEl.textContent = aboCompareTarget ? fmt(aboCompareTarget) : '';
    }

    // CTA: show abo total when subscription mode is active, otherwise the running
    // one-shoot total already computed by changeQuantity (which applies the
    // quantity-tier discount — leaving it untouched in one-shoot mode).
    const aboActive = !!document.querySelector('.abos__abo.active');
    if (aboActive) {
        document.querySelectorAll('[data-price]').forEach((el) => {
            el.textContent = fmt(aboTotal);
        });
        document.querySelectorAll('[data-compare-at-price]').forEach((el) => {
            if (aboTotal < baseTotal) {
                el.textContent = fmt(baseTotal);
                el.classList.remove('hidden');
            } else {
                el.classList.add('hidden');
            }
        });
    }
}

function updateProductItemsScroll() {
    document.querySelectorAll('.product-form__products-wrapper .product-form__product-items').forEach((el) => {
        if (el.scrollHeight > el.clientHeight) {
            el.classList.add('has-scroll');
        } else {
            el.classList.remove('has-scroll');
        }
    });
}
window.addEventListener('load', updateProductItemsScroll);
window.addEventListener('resize', updateProductItemsScroll);

// Global click handler for gift cards (free gift selector).
// Tier mode: single selection across the whole selector (one gift), no
// toggle off (keeps a gift selected once at least one tier is unlocked).
// Legacy mode: single selection across the whole selector, toggleable,
// with banner price update.
document.addEventListener('click', (event) => {
    const card = event.target.closest('.product-form__gift-card[data-gift-variant-id]');
    if (!card) return;
    const tierStep = card.dataset.giftTierStep;
    if (tierStep) {
        const selector = card.closest('.product-form__gift-selector');
        if (!selector) return;
        selector.querySelectorAll('.product-form__gift-card.active').forEach((c) => c.classList.remove('active'));
        card.classList.add('active');
        return;
    }
    const priceWrapper = document.querySelector('[data-gift-banner-price-wrapper]');
    const priceEl = document.querySelector('[data-gift-banner-price]');
    if (card.classList.contains('active')) {
        card.classList.remove('active');
        window.SELECTED_GIFT_VARIANT_ID = null;
        if (priceWrapper) priceWrapper.style.display = 'none';
    } else {
        document.querySelectorAll('.product-form__gift-card').forEach((c) => c.classList.remove('active'));
        card.classList.add('active');
        window.SELECTED_GIFT_VARIANT_ID = card.dataset.giftVariantId;
        if (priceWrapper && priceEl && card.dataset.productPrice) {
            priceEl.textContent = card.dataset.productPrice;
            priceWrapper.style.display = '';
        }
    }
});

// Global click handler for frequency tabs (subscription)
document.addEventListener('click', (event) => {
    const tab = event.target.closest('.abos__frequency-tab[data-selling-plan-id]');
    if (!tab) return;
    document.querySelectorAll('.abos__frequency-tab').forEach((t) => t.classList.remove('actif'));
    tab.classList.add('actif');
    if (typeof PACK_SELECTION !== 'undefined') {
        PACK_SELECTION.selling_plan_id = tab.dataset.sellingPlanId;
    }
    updateAboPriceLabels();
});

// Global click handler for abo / one-shoot toggle
document.addEventListener('click', (event) => {
    const aboCard = event.target.closest('[data-abo-recharge]');
    if (!aboCard) return;
    const container = aboCard.closest('.product-form__abos');
    if (!container) return;
    if (aboCard.classList.contains('abos__one-shoot')) {
        container.querySelector('.abos__abo')?.classList.remove('active');
        aboCard.classList.add('active');
    } else {
        container.querySelector('.abos__one-shoot')?.classList.remove('active');
        aboCard.classList.add('active');
    }
    // Switching modes must refresh CTA price; one-shoot path needs the running
    // total recomputed by changeQuantity (with quantity-tier discount).
    if (aboCard.classList.contains('abos__one-shoot')) {
        const anyQtyInput = document.querySelector('.product-form__product-item quantity-input');
        if (anyQtyInput) anyQtyInput.dispatchEvent(new CustomEvent('updateContent'));
    } else {
        updateAboPriceLabels();
    }
    updateGiftSelectorVisibility();
});

// Initial state: gift selector reflects whichever card is active on load.
window.addEventListener('DOMContentLoaded', () => updateGiftSelectorVisibility());

// Add free gift(s) to cart as a separate request (not mixed with bundle items).
// Tier mode: one single gift across all visible tiers.
// Legacy mode: single gift via window.SELECTED_GIFT_VARIANT_ID.
// Boîte mode: one gift per visible .product-form__progress-gift block.
window.addFreeGiftToCart = function () {
    const TAG = '[GIFT][perso]';
    const items = [];
    const seen = new Set();

    const selector = document.querySelector('.product-form__gift-selector');
    if (selector && !selector.classList.contains('hidden')) {
        const requireAbo = selector.dataset.giftNoAbo !== 'true';
        if (!requireAbo || isAboActive()) {
            const isTierMode = selector.dataset.giftSelectorMode === 'tier';
            if (isTierMode) {
                const activeCard = selector.querySelector('.product-form__gift-tier:not(.hidden) .product-form__gift-card.active');
                console.log(`${TAG} tier mode, activeCard=${!!activeCard}`);
                if (activeCard) {
                    const variantId = activeCard.dataset.giftVariantId;
                    const id = Number(variantId);
                    if (variantId && !Number.isNaN(id)) {
                        items.push({ id, quantity: 1 });
                        seen.add(id);
                    }
                }
            } else if (window.SELECTED_GIFT_VARIANT_ID) {
                const id = Number(window.SELECTED_GIFT_VARIANT_ID);
                if (!Number.isNaN(id) && !seen.has(id)) {
                    items.push({ id, quantity: 1 });
                    seen.add(id);
                }
            }
        }
    }

    document.querySelectorAll('.product-form__progress-gift:not(.hidden)').forEach((block) => {
        const activeItem = block.querySelector('.product-form__progress-gift-item.active');
        const variantId = activeItem && activeItem.dataset.giftVariantId;
        if (!variantId) return;
        const id = Number(variantId);
        if (Number.isNaN(id) || seen.has(id)) return;
        items.push({ id, quantity: 1 });
        seen.add(id);
    });

    if (items.length === 0) {
        console.warn(`${TAG} no gift items collected, request not sent`);
        return Promise.resolve();
    }
    console.log(`${TAG} POST /cart/add.js payload:`, items);
    return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
    }).then(async (res) => {
        const body = await res.json().catch(() => null);
        if (!res.ok) {
            console.error(`${TAG} /cart/add.js failed`, res.status, body);
        }
        return body;
    }).catch((err) => console.error(`${TAG} /cart/add.js network error:`, err));
};

class ProductTemplate extends HTMLElement {
    constructor() {
        super();


        this.initSwiper();

        this.querySelector('.product-form__submit').addEventListener('click', this.submitForm.bind(this));
        this.initEvents();

        this.querySelectorAll('.product-form__products--navigation__item').forEach((elem) => {
            elem.addEventListener('click', this.updateCollectionContent.bind(this))
        })

        document.querySelector('.product-form__products--navigation__item:not(.hidden-force)').click();

        this.calculateShipping();


        document.querySelectorAll('[data-open-modal-product]').forEach((elem) => {
            elem.addEventListener('click', this.toggleFaqItemItems.bind(this));
        });


        this.all_packs_container = document.querySelectorAll("pack-item");
        this.last_number_selection = 0;
        this.first_load = true;
        this.content_updated = false;

        let parent = document.querySelector('.product-form__submit').parentElement;

        while (parent) {
            const hasOverflow = getComputedStyle(parent).overflow;
            if (hasOverflow !== 'visible') {
                console.log(hasOverflow, parent);
            }
            parent = parent.parentElement;
        }

    }


    initSwiper() {
        const swiper = new Swiper('.product-media__items-medias .swiper', {
            slidesPerView: 'auto',
            navigation: {
                nextEl: '.product-media__items-medias .swiper-button-next',
                prevEl: '.product-media__items-medias .swiper-button-prev',
            },

        });
        const swiper2 = new Swiper('.product-media__items-medias .swiper_second', {
            slidesPerView: 'auto',
            navigation: {
                nextEl: '.product-media__items-medias .swiper_second .swiper-button-next',
                prevEl: '.product-media__items-medias .swiper_second .swiper-button-prev',
            },

        });
    }


    updateCollectionContent(e) {
        let current = e.currentTarget;
        let collection_id = current.dataset.handle;

        document.querySelectorAll('.product-form__products--navigation__item').forEach((elem) => {
            elem.classList.remove('actif');
        })

        current.classList.add('actif');

        document.querySelectorAll('.product-form__product-item[data-handle]').forEach((elem) => {
            elem.classList.add('hidden');
        })

        // if product-form__product-item data-handle contain the collection_id we remove the hidden class

        document.querySelectorAll(`.product-form__product-item[data-handle]`).forEach((elem) => {
            let elem_collection_id = elem.dataset.handle.split(' , ');
            console.log(elem_collection_id);

            if (elem_collection_id.includes(collection_id)) {
                elem.classList.remove('hidden');
            }
        }
        )


    }

    calculateShipping() {
        if (this.querySelector('.product-form__icon')) {
            // calculate shipping date from today + shipping delay exclude weekends
            let shipping_date = new Date(new Date().getTime());
            let shipping_delay = parseInt(this.getAttribute('data-shipping-delay'));


            for (var i = 0; i < shipping_delay; i++) {
                shipping_date.setDate(shipping_date.getDate() + 1);
                if (shipping_date.getDay() == 6) {
                    shipping_date.setDate(shipping_date.getDate() + 2);
                }
                if (shipping_date.getDay() == 0) {
                    shipping_date.setDate(shipping_date.getDate() + 1);
                }
            }

            // get french date format day month year
            let shipping_date_format = shipping_date.toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });

            for (let i = 0; i < document.querySelectorAll('.product-form__icon').length; i++) {
                let html = document.querySelectorAll('.product-form__icon')[i].innerHTML;
                if (html.indexOf('[date]') > -1) {
                    document.querySelectorAll('.product-form__icon')[i].innerHTML = html.replace('[date]', shipping_date_format);
                }
            }
        }
    }

    getActiveSellingPlan() {
        // Returns the selling_plan ID if subscription is active, or null for one-time purchase.
        const aboCard = document.querySelector('.abos__abo.active');
        if (!aboCard) return null;
        const activeTab = document.querySelector('.abos__frequency-tab.actif[data-selling-plan-id]');
        return activeTab ? activeTab.dataset.sellingPlanId : null;
    }

    submitForm() {
        const sellingPlan = this.getActiveSellingPlan();

        const activePackVariant = document.querySelector('.variant-item__pack.active');
        if (activePackVariant) {

            let quantity = 1;
            let variant_id = parseInt(activePackVariant.dataset.productVariantId);

            const cartItem = { id: variant_id, quantity: quantity };
            if (sellingPlan) cartItem.selling_plan = Number(sellingPlan);

            const data = { items: [cartItem] };

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then((response) => {
                console.log(response);
                return window.addFreeGiftToCart();
            }).then(() => {
                this.submitBundle();
            }).catch((error) => {
                console.error('Error:', error);
            })

        } else {
            document.querySelector(".product-form__submit").classList.add("loading");

            let selections_items = [];

            let packs__quantity = 0;

            for (const item of PACK_SELECTION.pack_items) {
                packs__quantity += item.quantity;
            }

            if (packs__quantity != 0) {
                for (const item of PACK_SELECTION.pack_items) {
                    if (item.quantity > 0) {
                        const cartItem = { id: item.id, quantity: item.quantity };
                        if (sellingPlan) {
                            const itemPlanId = getSellingPlanIdForHandle(item.handle);
                            if (itemPlanId) cartItem.selling_plan = Number(itemPlanId);
                        }
                        selections_items.push(cartItem);
                    }
                }

                const data = { items: selections_items };

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then((response) => {
                    console.log(response);
                    return window.addFreeGiftToCart();
                }).then(() => {
                    this.submitBundle();
                }).catch((error) => {
                    console.error('Error:', error);
                })
            }
        }
    }

    submitBundle() {
        document.querySelector(".product-form__submit").classList.remove("loading");
    }

    initEvents() {
        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });

        document
            .querySelectorAll(".selection-packs-upgrade__decline")
            .forEach((button) => {
                button.addEventListener("click", () => {
                    document
                        .querySelectorAll(".selection-packs-upgrade")
                        .forEach((item) => {
                            item.classList.remove("open");
                        });
                });
            });
    }


    toggleFaqItemItems(e) {
        e.currentTarget.classList.toggle("faq-open");

        const item = e.currentTarget.closest('.product-form__product-item').querySelector(".product-item__details");

        item.slideToggle("250");
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }
}

customElements.define('product-template', ProductTemplate);

window.addEventListener('load', function () {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
});
window.addEventListener('resize', function () {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
});

class VariantItem extends HTMLElement {
    constructor() {
        super();

        this.updatePackContent()
        this.addEventListener('click', this.toggleVariant.bind(this));


        let changeVariantEl = document.querySelector('[data-change-variant]');
        if (changeVariantEl) {
            let handle_pack = changeVariantEl.dataset.changeVariant;
            //  if url contain ?pack-degustation or ?compo we open the modal
            if (window.location.href.indexOf(`?${handle_pack}`) > -1) {
                document.querySelector('.variant-item__pack')?.click();
            }
        }
    }

    toggleVariant() {
        document.querySelectorAll('variant-item').forEach((item) => {
            item.classList.remove('active');
        });
        this.classList.add('active');

        const submitBtn = document.querySelector('.product-form__submit');
        if (submitBtn) {
            if (this.classList.contains('disabled')) {
                submitBtn.classList.add('disabled');
            } else {
                submitBtn.classList.remove('disabled');
            }
        }

        this.updatePackContent();
    }


    updatePackContent() {

        if (this.classList.contains("variant-item__compo")) {

            document.querySelectorAll('.product-media__item__custom').forEach((elem) => {
                elem.classList.remove('active');
            });
            document.querySelectorAll('.product-media__item:not(.product-media__item__custom, .product-media__item--image)').forEach((elem) => {
                elem.classList.remove('hidden');
            });
            document.querySelector('.product-form__products__compo')?.classList.remove('hidden');
            document.querySelector('.product-form__variant__compareatprice')?.classList.remove('hidden');
            document.querySelector('.product-form__variant__compareatprice_pack')?.classList.add('hidden');
            document.querySelector('.product-form__pack-price')?.classList.add('hidden');
            document.querySelector('.product-form__products__pack')?.classList.add('hidden');
            document.querySelector('.product-form__variant__price.perso')?.classList.remove('hidden');
            document.querySelector('.product-form__variant__price.pack')?.classList.add('hidden');

            document.querySelector('.main-product-media__container--custom_second')?.classList.add('hidden');
            document.querySelector('.main-product-media__container--custom')?.classList.remove('hidden-force');

            document.querySelector('.product-media__items-medias_second')?.classList.add('hidden');
            document.querySelector('.product-media__items-medias_first')?.classList.remove('hidden');

            // We update the pack selection object
            PACK_SELECTION = {
                pack_items: PACK_SELECTION.pack_items ? PACK_SELECTION.pack_items : packItems,
            };

            if (PACK_SELECTION.pack_items) {
                let total = 0;
                for (const item of PACK_SELECTION.pack_items) {
                    total += item.quantity;
                }

                if (total == 0) {
                    document.querySelector('.product-form__submit')?.classList.add('disabled');
                    const vp1 = document.querySelector('.product-form__variant-price');
                    if (vp1) vp1.style.display = 'none';

                }

                if (total != 0) {
                    document.querySelector('.product-form__content-items')?.classList.remove('hidden');
                    document.querySelector('.product-form__submit')?.classList.remove('disabled');
                    const vp2 = document.querySelector('.product-form__variant-price');
                    if (vp2) vp2.style.display = 'block';
                }

                document.querySelectorAll('[data-action="increment"]').forEach((elem) => {
                    elem.setAttribute("disabled", "false");
                });
            }

            // this.updatePriceCta();
            this.updatePageContent();

        }
        else {


            document.querySelector('.product-form__products__compo')?.classList.add('hidden');
            document.querySelector('.product-form__submit')?.classList.remove('disabled');
            document.querySelector('.product-form__pack-price')?.classList.remove('hidden');
            document.querySelector('.product-form__variant__compareatprice')?.classList.add('hidden');
            document.querySelector('.product-form__variant__compareatprice_pack')?.classList.remove('hidden');
            document.querySelector('.product-form__content-items')?.classList.add('hidden');
            const vp3 = document.querySelector('.product-form__variant-price');
            if (vp3) vp3.style.display = 'none';
            document.querySelector('.product-form__products__pack')?.classList.remove('hidden');
            document.querySelector('.product-form__variant__price.perso')?.classList.add('hidden');
            document.querySelector('.product-form__variant__price.pack')?.classList.remove('hidden');

            document.querySelector('.product-media__items-medias_second')?.classList.remove('hidden');
            document.querySelector('.product-media__items-medias_first')?.classList.add('hidden');

            document.querySelectorAll('.product-media__item__custom').forEach((elem) => {
                elem.classList.add('active');
            });

            document.querySelectorAll('.product-media__item:not(.product-media__item__custom, .product-media__item--image)').forEach((elem) => {
                elem.classList.add('hidden');
            });

            document.querySelector('.main-product-media__container--custom_second')?.classList.remove('hidden');
            document.querySelector('.main-product-media__container--custom').classList.add('hidden-force');

        }
    }

    updatePageContent() {

        //  change source image to show the pack selection

        const mediaEl = document.querySelector('caps-product-media');
        if (mediaEl && mediaEl.goToVariant && PACK_SELECTION.pack_variant_id) {
            mediaEl.goToVariant(PACK_SELECTION.pack_variant_id);
        }

        document.querySelectorAll('.product-media__item--image').forEach((elem) => {
            elem.parentNode.classList.add('hidden');
        })

        const activeImage = document.querySelector(`#image-${PACK_SELECTION.pack_variant_id}`);
        if (activeImage) activeImage.parentNode.classList.remove('hidden');

    }

}

customElements.define('variant-item', VariantItem);

class QuantityInput extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[name="quantity"]');
        this.addEventListener("click", this.changeQuantity.bind(this));
        this.addEventListener("updateContent", this.changeQuantity.bind(this));

        this.querySelector('.product--quantity__init').addEventListener('click', function () {
            this.querySelector('[data-action="increment"]').click();
            this.querySelector('.product--quantity__init').classList.add('hidden');
        }.bind(this));


        this.updatecoffeesCounter();

    }

    changeQuantity(event) {

        document.querySelector('.product-form__custom_label')?.classList.remove('hidden')

        let target = event.target;
        let total = 0;

        // Get the total quantity of coffees in the pack
        for (const item of PACK_SELECTION.pack_items) {
            total += item.quantity;
        }

        // console.log(total, PACK_SELECTION.coffee_times);

        const value = parseInt(this.input.value);

        if (target.classList.contains("quantity-input__btn")) {
            if (target.dataset.action === "increment") {

                target
                    .closest("quantity-input")
                    .querySelector('[data-action="decrement"]')
                    .removeAttribute("disabled");
                // We update the input value with the new quantity
                this.input.value = parseInt(value) + 1;
                if (this.input.value == this.input.max) {
                    this.parentNode.classList.add('out-of-stock-dinamique');
                }
            } else if (target.dataset.action === "decrement") {
                this.parentNode.classList.remove('out-of-stock-dinamique');
                document.querySelectorAll('[data-action="increment"]').forEach((elem) => {
                    elem.setAttribute("disabled", "false");
                });
                if (value > 0) {
                    this.input.value = parseInt(value) - 1;
                    // We update the input value with the new quantity
                    if (this.input.value == 0) {
                        target.setAttribute("disabled", "disabled");
                    }

                } else {
                }
            }
        }

        let total_coffees = 0;

        if (this.input.value == 0) {
            this.querySelector('.product--quantity__init').classList.remove('hidden');
        }

        let quantity_inputs = document.querySelectorAll(
            '.product-form__product-item quantity-input [name="quantity"][data-handle]'
        );

        for (const input of quantity_inputs) {
            total_coffees += parseInt(input.value);
        }

        // Build steps array from DOM
        const steps = [1, 2, 3].map(function (i) {
            var el = document.querySelector('.product-form__progress--bar-item-' + i + '[data-reduction-step]');
            return {
                el: el,
                threshold: Number(el.dataset.reductionStep),
                reduction: Number(el.dataset.reduction),
                isGift: el.dataset.rewardType === 'gift',
                fillEl: el.querySelector('.progress__fill .fill__content')
            };
        });

        let current_reduction = 0;
        let current_reste = 0;
        let current_reduction_content = 0;

        // Find which tier the user is in (activeIndex = last completed step, -1 if none)
        var activeIndex = -1;
        for (var s = steps.length - 1; s >= 0; s--) {
            if (total_coffees >= steps[s].threshold) { activeIndex = s; break; }
        }

        // Find which tier is currently filling (currentIndex = step being filled)
        var currentIndex = 0;
        for (var s = 0; s < steps.length; s++) {
            if (total_coffees <= steps[s].threshold) { currentIndex = s; break; }
            if (s === steps.length - 1) currentIndex = s;
        }

        // Update each step's fill bar and active state
        for (var i = 0; i < steps.length; i++) {
            var step = steps[i];
            var prevThreshold = i > 0 ? steps[i - 1].threshold : 0;
            var range = step.threshold - prevThreshold;

            if (total_coffees >= step.threshold) {
                // Step fully completed — animate fill first, then add active after transition
                step.fillEl.style.width = '100%';
                if (!step.el.classList.contains('active')) {
                    (function (el) {
                        el.querySelector('.progress__fill .fill__content').addEventListener('transitionend', function handler() {
                            el.classList.add('active');
                            el.querySelector('.progress__fill .fill__content').removeEventListener('transitionend', handler);
                        });
                    })(step.el);
                }
            } else if (i === currentIndex && total_coffees > prevThreshold) {
                // Step currently filling
                var progress = ((total_coffees - prevThreshold) / range) * 100;
                step.fillEl.style.width = progress + '%';
                step.el.classList.remove('active');
            } else {
                // Step not reached — reset
                step.fillEl.style.width = '0%';
                step.el.classList.remove('active');
            }
        }

        // Compute current reduction (highest completed non-gift step)
        for (var i = 0; i <= activeIndex; i++) {
            if (!steps[i].isGift) current_reduction = steps[i].reduction;
        }

        // Compute remaining & next reduction content
        var nextStep = activeIndex + 1 < steps.length ? steps[activeIndex + 1] : null;
        if (nextStep) {
            current_reste = nextStep.threshold - total_coffees;
            current_reduction_content = nextStep.reduction;
        } else if (activeIndex >= 0) {
            current_reste = 0;
            current_reduction_content = steps[activeIndex].reduction;
        } else {
            current_reste = steps[0].threshold - total_coffees;
            current_reduction_content = steps[0].reduction;
        }

        // Handle custom label complete/text toggle (step 3 specific)
        var lastStep = steps[steps.length - 1];
        if (total_coffees >= lastStep.threshold) {
            document.querySelector('.product-form__custom_label-text')?.classList.add('hidden');
            document.querySelector('.product-form__custom_label-complete')?.classList.remove('hidden');
            var customLabelComplete = document.querySelector('.product-form__custom_label-complete .progress__reduction span');
            if (customLabelComplete) customLabelComplete.textContent = lastStep.reduction;
        } else {
            document.querySelector('.product-form__custom_label-text')?.classList.remove('hidden');
            document.querySelector('.product-form__custom_label-complete')?.classList.add('hidden');
        }

        let current_reduction_details = current_reduction / 100;
        if (current_reduction == 0) {
            current_reduction_details = 1
        }

        console.log(current_reduction_details);

        if (current_reduction == 0) {
            document.querySelectorAll('[data-current-price-item-collection]').forEach((elem) => {
                let currentPrice = Number(elem.dataset.currentPriceItemCollection);
                elem.querySelector('[data-current-compare-reduction]').textContent = '';
                elem.querySelector('[data-current-price-reduction]').textContent = (currentPrice / 100).toFixed(2) + '€';
            });
        } else {
            document.querySelectorAll('[data-current-price-item-collection]').forEach((elem) => {
                let currentPrice = Number(elem.dataset.currentPriceItemCollection);
                elem.querySelector('[data-current-compare-reduction]').textContent = (currentPrice / 100).toFixed(2) + '€';
                // Arrondi au centime pour matcher le calcul Shopify par ligne
                const discounted = currentPrice - Math.round(currentPrice * current_reduction / 100);
                elem.querySelector('[data-current-price-reduction]').textContent = (discounted / 100).toFixed(2) + '€';
            });
        }



        const restEl = document.querySelector('[data-current-rest]');
        if (restEl) restEl.textContent = current_reste;
        const reductionSpan = document.querySelector('[data-current-reduction] span');
        if (reductionSpan) reductionSpan.textContent = current_reduction_content;

        if (total_coffees === 0) {
            document.querySelector('.product-form__content-items')?.classList.add('hidden');
            const variantPrice = document.querySelector('.product-form__variant-price');
            if (variantPrice) variantPrice.style.display = 'none';
        }
        else {
            const variantPrice = document.querySelector('.product-form__variant-price');
            if (variantPrice) variantPrice.style.display = 'block';
        }
        this.updateSelectionContent();
        this.updatecoffeesCounter();
        this.updateProgressGiftBlocks(total_coffees);
        let total_weight = 0;
        let number_cofee = 0;
       let coffe_by_paquet = document.querySelector('.product-list__pack-content-perso[data-coffee-times]').dataset.coffeeTimes;
        if (document.querySelector('[data-current-machine="dolce-gusto"]')) {
            coffe_by_paquet = 8.5;
        } else {
            coffe_by_paquet = 5;
        }
      
        for (const item of PACK_SELECTION.pack_items) {
            if (item.quantity != 0) {
                total_weight += Math.floor(item.weight * 1) * item.quantity;
                number_cofee += Math.floor(item.weight / coffe_by_paquet) * item.quantity;
            }
        }
         console.log(total_weight);
      
        console.log(total_weight / coffe_by_paquet);
        let total_coffees_number_coffee = 0;
        for (const input of document.querySelectorAll('.product-form__product-item quantity-input:not(.quantity-input-boite) [name="quantity"][data-handle]')) {
            total_coffees_number_coffee += parseInt(input.value);
        }
      
        const nbPaquetEl = document.querySelector('[data-nb-paquet]');
        if (nbPaquetEl) nbPaquetEl.textContent = number_cofee;

        const selectionGlobal = document.querySelector('.selection__global [data-nb-pack]');
        if (selectionGlobal) selectionGlobal.textContent = total_coffees;
        // In boite mode all quantity inputs are boite-type, so total_coffees_number_coffee is 0.
        // Fall back to total_coffees so the summary unit count is correct for both modes.
        const isBoiteMode = document.querySelector('.product-form.display-boites') != null;
        const maxSachetQty = document.querySelector('[data-max-sachet] [data-quantity]');
        if (maxSachetQty) maxSachetQty.textContent = isBoiteMode ? total_coffees : total_coffees_number_coffee;
        const maxBoitesQty = document.querySelector('[data-max-boites] [data-quantity]');
        if (maxBoitesQty) maxBoitesQty.textContent = total_coffees;
       
        let total_price = 0

        console.log(total_price / 100);
        for (const item of PACK_SELECTION.pack_items) {
            if (item.quantity != 0) {
                total_price += item.price * item.quantity
            }
        }

        //  if current_reduction != 0 calcul price
        document.querySelector('[data-compare-at-price]')?.classList.add('hidden')

        // Free gift bonus: when a progress-gift step is reached, the active
        // gift's market value is added to the CTA compare-at price so the
        // user sees the full "value" they're getting.
        const giftBonusCents = getActiveGiftBonusCents();

        if (current_reduction != 0) {
            const priceCoffeeEl = document.querySelector('[data-price-coffee]');
            if (priceCoffeeEl?.parentNode?.parentNode) priceCoffeeEl.parentNode.parentNode.classList.remove('hidden');
            // Arrondi ligne par ligne pour matcher le calcul Shopify côté cart
            let total_price_final = 0;
            for (const item of PACK_SELECTION.pack_items) {
                if (item.quantity != 0) {
                    const line_price = item.price * item.quantity;
                    total_price_final += line_price - Math.round(line_price * current_reduction / 100);
                }
            }
            const compareAtPriceEl = document.querySelector('[data-compare-at-price]');
            if (compareAtPriceEl) {
                compareAtPriceEl.textContent = (total_price / 100).toFixed(2) + '€';
                compareAtPriceEl.classList.remove('hidden');
            }
            document.querySelector('[data-price]')?.setAttribute('textContent', '');
            const dataPriceEl = document.querySelector('[data-price]');
            if (dataPriceEl) dataPriceEl.textContent = (total_price_final / 100).toFixed(2) + '€';
            if (priceCoffeeEl) priceCoffeeEl.textContent = (total_price_final / number_cofee / 100).toFixed(2) + '€';
            const submitPrice = document.querySelector('.product-form__submit [data-price]');
            if (submitPrice) submitPrice.textContent = (total_price_final / 100).toFixed(2) + '€';
            const submitCompare = document.querySelector('.product-form__submit [data-compare-at-price]');
            if (submitCompare) {
                submitCompare.textContent = ((total_price + giftBonusCents) / 100).toFixed(2) + '€';
                submitCompare.classList.remove('hidden');
            }
        } else {
            document.querySelector('.product-form__variant__compareatprice')?.classList.add('hidden');
            document.querySelector('[data-price-coffee]')?.classList.remove('hidden');
            const dataPriceEl = document.querySelector('[data-price]');
            if (dataPriceEl) dataPriceEl.textContent = ((total_price) / 100).toFixed(2) + '€';
            const priceCoffeeEl = document.querySelector('[data-price-coffee]');
            if (priceCoffeeEl) priceCoffeeEl.textContent = (((total_price)).toFixed(2) / number_cofee / 100).toFixed(2) + '€';
            const submitPrice = document.querySelector('.product-form__submit [data-price]');
            if (submitPrice) submitPrice.textContent = ((total_price) / 100).toFixed(2) + '€';
            const submitCompare = document.querySelector('.product-form__submit [data-compare-at-price]');
            if (submitCompare) {
                if (giftBonusCents > 0) {
                    submitCompare.textContent = ((total_price + giftBonusCents) / 100).toFixed(2) + '€';
                    submitCompare.classList.remove('hidden');
                } else {
                    submitCompare.classList.add('hidden');
                }
            }
        }

        if (total_coffees == 0) {
            const priceCoffeeEl = document.querySelector('[data-price-coffee]');
            if (priceCoffeeEl) priceCoffeeEl.textContent = 0 + '€';
            document.querySelector('.product-form__submit')?.classList.add('disabled');
        }
        else {
            document.querySelector('.product-form__submit')?.classList.remove('disabled');
        }

        updateAboPriceLabels();
    }



    updatecoffeesCounter() { }

    updateProgressGiftBlocks(total_coffees = 0) {
        updateGiftSelectorVisibility(total_coffees);
        updateProgressGiftsDOM(total_coffees);
    }

    updateSelectionContent() {

        console.log('change quantity');
        const quantity_inputs = document.querySelectorAll(
            ".product-form__product-item quantity-input"
        );
        for (const input of quantity_inputs) {
            for (let item of PACK_SELECTION.pack_items) {
                // Update the quantity of each smoothie in the pack selection object
                if (item.handle === input.querySelector("input").dataset.handle) {
                    item.quantity = parseInt(input.querySelector("input").value);
                    console.log(item);
                }
            }
        }
        let index = 0;
        const packContentEl = document.querySelector("[data-pack-content]");
        if (!packContentEl) return;
        let content_pack = packContentEl.textContent;
        content_pack = '';
        let content_updated = '';

        console.log(PACK_SELECTION.pack_items);

        for (const item of PACK_SELECTION.pack_items) {
            if (item.quantity > 0) {
                console.log(item.title);
                document.querySelector('.product-form__content-items')?.classList.remove('hidden');
                if (index == 0) {
                    content_updated += (`${item.title} (${item.quantity})`);
                }
                else {
                    content_updated += (`, ${item.title} (${item.quantity})`);
                }
                index++;
            }
        }

        packContentEl.textContent = content_updated;
        const summarySelection = document.querySelector(".product-form__pack-summary-selection");
        if (summarySelection) {
            if (content_updated.trim().length > 0) {
                summarySelection.classList.remove("hidden");
            } else {
                summarySelection.classList.add("hidden");
            }
        }
    }
}

if (customElements.get("quantity-input") === undefined) {
    customElements.define("quantity-input", QuantityInput);
}


const disabledLinks = (urls, attr, setAttr) => {
    [...urls].forEach(url => {
        url.setAttribute(attr, setAttr)
    })
}

const blockedLinks = (down) => {
    const allLinks = document.querySelectorAll('.url-card');
    down
        ? disabledLinks(allLinks, 'disabled', 'disabled')
        : disabledLinks(allLinks, 'disabled', '')
}


